import { createSlice } from "@reduxjs/toolkit";
import deleteTeleModPrice from "../../../rtk-apis/Setting/deleteTeleModPrice";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const deleteTeleModPriceSlice = createSlice({
    name: "deleteTeleModPriceSlice",
    initialState,
    reducers: {
        clearDeleteTeleModPriceState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteTeleModPrice.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(deleteTeleModPrice.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(deleteTeleModPrice.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default deleteTeleModPriceSlice.reducer;
export const { clearDeleteTeleModPriceState } = deleteTeleModPriceSlice.actions;
